
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 48 48"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a","transform":"translate(2 2)"}},[_c('path',{attrs:{"d":"M42.5 18H22v8.5h11.8C32.7 31.9 28.1 35 22 35a13 13 0 010-26 12.72 12.72 0 018.1 2.9l6.4-6.4A22 22 0 1022 44c11 0 21-8 21-22a18.25 18.25 0 00-.5-4z","fill":"none"}})])]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M0 37V11l17 13z","fill":"#fbbc05"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M0 11l17 13 7-6.1L48 14V0H0z","fill":"#ea4335"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M0 37l30-23 7.9 1L48 0v48H0z","fill":"#34a853"}})]),_c('g',{attrs:{"clip-path":"url(#a)"}},[_c('path',{attrs:{"d":"M48 48L17 24l-4-3 35-10z","fill":"#4285f4"}})])])
          )
        }
      }
    